import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { RefreshCcwDot} from "lucide-react"
import TextToSpeech from '../Learning/TextToSpeech';

const quotes = [
    "The best way to predict the future is to invent it.",
    "Don’t watch the clock; do what it does. Keep going.",
    "Success is not final, failure is not fatal: It is the courage to continue that counts.",
    "Act as if what you do makes a difference. It does.",
    "Happiness is not something ready made. It comes from your own actions.",
    "Believe you can and you're halfway there.",
    "Keep your face always toward the sunshine—and shadows will fall behind you."
];

const RandomQuote = () => {
    const [currentQuote, setCurrentQuote] = useState(quotes[0]);

    const getRandomQuote = () => {
        const randomIndex = Math.floor(Math.random() * quotes.length);
        setCurrentQuote(quotes[randomIndex]);
    };

    return (
        <div className="flex flex-col items-center justify-center h-[50vh] font-sans space-y-4">
            <h1 className="font-[Phudu] font-bold text-center text-2xl mb-6">DANH NGÔN MỖI NGÀY</h1>
            <motion.p
                key={currentQuote}
                className="text-2xl text-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                &ldquo;{currentQuote}&rdquo;
            </motion.p>
            <TextToSpeech text={currentQuote}/>
            <motion.button
                onClick={getRandomQuote}
                className="px-6 py-2 text-white bg-green-500 rounded hover:bg-green-600 focus:outline-none"
                whileHover={{ scale: 1.1 }}
                transition={{ type: 'spring', stiffness: 300 }}>
                <RefreshCcwDot />
            </motion.button>
        </div>
    );
};

export default RandomQuote;
